module.exports = __webpack_public_path__ + "media/images/home-banners/birds-84665_1920-2bebff4159640294842fd74ed9ccc4de.jpg";